export const GlobalStyle = {
    html: {
        overflow: 'hidden',
        fontSize: '16px',
    },
    'html, body': {
        width: '100%',
        height: '100%',
    },
    '#app': {
        display: 'flex',
        flexFlow: 'column nowrap',
        width: '100%',
        height: '100%',
        overflow: 'auto',
    },
    '#content': {
        display: 'flex',
        flexFlow: 'column nowrap',
        flex: '1 0 auto',
        paddingTop: '85px',
        ['@media (max-width: 980px)']: {
            paddingTop: '65px',
        },
    },
    '.hidden': {
        display: 'none',
    },
    '.usable-hidden-label': {
        marginLeft: '0 !important',
    },
    '.usable-hidden': {
        width: '0.5px !important',
        height: '0.5px !important',
        opacity: '0 !important',
        overflow: 'hidden !important',
        position: 'absolute !important',
        zIndex: -1,
    },
    '.text-bold': {
        fontWeight: 700,
    },
};
